import { createRenderer } from '@ycos/fela';
import { MRPTheme, MRPThemeRtl, NAPTheme, TONTheme, NAPThemeRtl, breakpoints } from '@ycos/themes';
import { getTheme } from './utils';

export const themes = {
    mrp: {
        ...MRPTheme,
        breakpoints,
        skeleton: {
            productInfoMargin: `${2 * MRPTheme.spacingMultiplier}px 0`,
            paginationDisplay: 'flex',
            wrapperVerticalPadding: MRPTheme.spacingMultiplier,
            wrapperHorizontalPadding: MRPTheme.spacingMultiplier,
            color: MRPTheme.typography.colors.PrimaryGrey,
        },
    },
    mrpRtl: {
        ...MRPThemeRtl,
        breakpoints,
        skeleton: {
            productInfoMargin: `${2 * MRPTheme.spacingMultiplier}px 0`,
            paginationDisplay: 'flex',
            wrapperVerticalPadding: MRPTheme.spacingMultiplier,
            wrapperHorizontalPadding: MRPTheme.spacingMultiplier,
            color: MRPTheme.typography.colors.PrimaryGrey,
        },
    },
    nap: {
        ...NAPTheme,
        breakpoints,
        skeleton: {
            carouselTabletWidth: '45%',
            carouselTabletFlexGrow: '0',
            productInfoMargin: `${6 * NAPTheme.spacingMultiplier}px ${2 * NAPTheme.spacingMultiplier}px ${8 * NAPTheme.spacingMultiplier}px`,
            paginationDisplay: 'none',
            wrapperVerticalPadding: '0',
            wrapperHorizontalPadding: '0',
            color: NAPTheme.typography.colors.PrimaryGrey,
        },
    },
    napRtl: {
        ...NAPThemeRtl,
        breakpoints,
        skeleton: {
            carouselTabletWidth: '45%',
            carouselTabletFlexGrow: '0',
            productInfoMargin: `${6 * NAPTheme.spacingMultiplier}px ${2 * NAPTheme.spacingMultiplier}px ${8 * NAPTheme.spacingMultiplier}px`,
            paginationDisplay: 'none',
            wrapperVerticalPadding: '0',
            wrapperHorizontalPadding: '0',
            color: NAPTheme.typography.colors.PrimaryGrey,
        },
    },
    ton: {
        ...TONTheme,
        breakpoints,
        skeleton: {
            productInfoMargin: `${2 * TONTheme.spacingMultiplier}px 0`,
            paginationDisplay: 'flex',
            marginLeft: `${TONTheme.spacingMultiplier}px`,
            wrapperVerticalPadding: TONTheme.spacingMultiplier,
            wrapperHorizontalPadding: TONTheme.spacingMultiplier,
            color: TONTheme.typography.colors.SecondaryLightGrey,
        },
    },
    tonRtl: {
        ...TONTheme,
        breakpoints,
        skeleton: {
            productInfoMargin: `${2 * TONTheme.spacingMultiplier}px 0`,
            paginationDisplay: 'flex',
            marginLeft: `${TONTheme.spacingMultiplier}px`,
            wrapperVerticalPadding: TONTheme.spacingMultiplier,
            wrapperHorizontalPadding: TONTheme.spacingMultiplier,
            color: TONTheme.typography.colors.SecondaryLightGrey,
        },
    },
};

export default ({ brand = 'mrp', selectorPrefix = '', custom = {} }) => {
    const theme = getTheme(themes[brand], custom);

    return createRenderer(
        theme,
        [],
        {
            ie11: '@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none)',
        },
        selectorPrefix,
    );
};
